export default __webpack_public_path__ + "static/media/pre-warmed-mailbox.fb1fc447.svg";